module.exports = __webpack_public_path__ + "static/slide-4-8507b9df2d716a8e3804acede6884050.jpg";